import React from 'react';
import styled from 'styled-components';
import { Alignment, Fit, Layout, useRive } from '@rive-app/react-canvas';
import { LabelUppercase } from '../elements/Text';
// @ts-expect-error - .riv files are not supported by typescript
import loaderAnim from '../../assets/rive-animations/minimal-loader.riv';

const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
`;

export default function Loader({ 
  title = "Loading...",
  size = 300
 }: { title?: string, size?: number }) {
  const [showTitle, setShowTitle] = React.useState(false);

  const { RiveComponent } = useRive({
    src: loaderAnim,
    autoplay: true,
    onPlay: () => {
      setShowTitle(true);
    },
    layout: new Layout({
      fit: Fit.Fill,
      alignment: Alignment.Center,
    }),
  });
  return (
      <CenteredContainer>
        <div style={{ height: size, width: size }}>
          <RiveComponent />
        </div>
        {showTitle && (
          <LabelUppercase style={{ margin: 0, marginTop: -100 }}>
            {title}
          </LabelUppercase>
        )}
      </CenteredContainer>
  );
}